module.exports = __webpack_public_path__ + "img/中共广州市南沙区委员会组织部.72378abe.png";